var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImportIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4999 0.532593H9.49992V2.53259H13.4999C14.0522 2.53259 14.4999 2.98031 14.4999 3.53259V13.5326C14.4999 14.0849 14.0522 14.5326 13.4999 14.5326H9.49992V16.5326H13.4999C15.1568 16.5326 16.4999 15.1894 16.4999 13.5326V3.53259C16.4999 1.87574 15.1568 0.532593 13.4999 0.532593Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.29302 8.97825H0.500122V7.97825H8.29302L5.96459 5.64983C5.76933 5.45456 5.76933 5.13798 5.96459 4.94272C6.15985 4.74746 6.47643 4.74746 6.67169 4.94272L9.85368 8.1247C10.0489 8.31996 10.0489 8.63654 9.85368 8.83181L6.67169 12.0138C6.47643 12.209 6.15985 12.209 5.96459 12.0138C5.76933 11.8185 5.76933 11.5019 5.96459 11.3067L8.29302 8.97825Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportIcon);
export default __webpack_public_path__ + "static/media/import-icon.1b5b0eb21c1096051216376bff007641.svg";
export { ForwardRef as ReactComponent };